var _defs, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0;}.cls-2{fill:#935fe8;}.cls-3{fill:#efe9ff;}.cls-4{fill:#784ace;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -0.18,
    y: 0.9,
    width: 600,
    height: 600
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.66,
    y: 1.79,
    width: 600,
    height: 600
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -0.18,
    y: 0.9,
    width: 600,
    height: 600
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.22,
    y: 0.79,
    width: 600,
    height: 600
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "training_diary_new_entry"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 300.5,
    cy: 299.71,
    r: 300
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M447.82,244.26H357.55V159.09a56.19,56.19,0,0,0-56-56h0a56.2,56.2,0,0,0-56,56v85.17H165.33a56.19,56.19,0,0,0-56,56h0a56.19,56.19,0,0,0,56,56h80.16v85.27a56.2,56.2,0,0,0,56,56h0a56.19,56.19,0,0,0,56-56V356.31h90.27a56.19,56.19,0,0,0,56-56h0A56.19,56.19,0,0,0,447.82,244.26Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "training_diary_new_entry_copy",
    "data-name": "training_diary_new_entry copy"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 300.5,
    cy: 300.71,
    r: 300
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M447.82,244.26H357.55V159.09a56.19,56.19,0,0,0-56-56h0a56.2,56.2,0,0,0-56,56v85.17H165.33a56.19,56.19,0,0,0-56,56h0a56.19,56.19,0,0,0,56,56h80.16v85.27a56.2,56.2,0,0,0,56,56h0a56.19,56.19,0,0,0,56-56V356.31h90.27a56.19,56.19,0,0,0,56-56h0A56.19,56.19,0,0,0,447.82,244.26Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNew);
export default __webpack_public_path__ + "static/media/add_new.11c90873c4f807979fc03166a66e0ec9.svg";
export { ForwardRef as ReactComponent };